import { useSuspenseQuery } from '@tanstack/react-query'

import { zGetResidentRestContractsByContractUuidPaymentsByMonthResponse as contractPaymentsByMonthResponseSchema } from '../../../common/generated/residentApiSchemas'
import { API_ENDPOINTS } from '../../../common/apiEndpoints'

import { get } from 'api/apiClient'

const paymentsByMonthSchema = contractPaymentsByMonthResponseSchema.shape.data

const paymentsByMonthQuery = (contractUuid: string) => {
  const endpoint = `${API_ENDPOINTS.CONTRACTS}/${contractUuid}/payments-by-month`

  return {
    queryKey: [endpoint],
    queryFn: () => get(endpoint, paymentsByMonthSchema),
  }
}

export const useAPIGetContractPaymentsByMonthSuspense = (
  contractUuid: string
) => useSuspenseQuery(paymentsByMonthQuery(contractUuid))
